import type { StructuredResource } from '@bamboohr/utils/lib/locale';

export default {
	'common-items-count': {
		translation: {
			one: '{{count}} item',
			other: '{{count}} items',
		},
	},
} satisfies StructuredResource;
